import company from "@/content/company";

export const COMPANY = company;
